import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useMessageBox } from "../Common/MessageBox";
import "./UserProfile.css";

const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { showInfo, MessageBoxComponent } = useMessageBox();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setIsOpen(false);
    logout(); // Use AuthContext logout
    // Force browser refresh to clear all memory state
    window.location.href = '/login';
  };

  const handleProfile = () => {
    setIsOpen(false);
    showInfo("Profile page coming soon!");
  };

  const handleSettings = () => {
    setIsOpen(false);
    navigate("/settings/shopify");
  };

  // Safe fallbacks for user data
  const name = user?.name || "John Doe";
  const email = user?.email || user?.gmail || "john@thriftlyst.com";
  const role = user?.role || "Admin";

  return (
    <div className="user-profile" ref={dropdownRef}>
      <button
        className="profile-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="User menu"
        aria-expanded={isOpen}
      >
        <div className="avatar">
          <span className="avatar-text">{name.charAt(0)}</span>
        </div>

        <div className="user-info">
          <span className="user-name">{name}</span>
          <span className="user-role">{role}</span>
        </div>

        <svg
          className={`dropdown-arrow ${isOpen ? "rotated" : ""}`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M2.5 4.5L6 8L9.5 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="profile-dropdown">
          <div className="dropdown-header">
            <div className="avatar-large">
              <span className="avatar-text">{name.charAt(0)}</span>
            </div>

            <div className="dropdown-user-info">
              <span className="dropdown-name">{name}</span>
              <span className="dropdown-email">{email}</span>
            </div>
          </div>

          <div className="dropdown-divider"></div>

          <div className="dropdown-menu">
            <button className="dropdown-item" onClick={handleProfile}>
              <span>My Profile</span>
            </button>

            <button className="dropdown-item" onClick={handleSettings}>
              <span>Settings</span>
            </button>

            <div className="dropdown-divider"></div>

            <button
              className="dropdown-item logout-item"
              onClick={handleLogout}
            >
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
      <MessageBoxComponent />
    </div>
  );
};

export default UserProfile;
